import { render, staticRenderFns } from "./device_packet_desc_info.vue?vue&type=template&id=3ff2583b&scoped=true&"
import script from "./device_packet_desc_info.vue?vue&type=script&lang=js&"
export * from "./device_packet_desc_info.vue?vue&type=script&lang=js&"
import style0 from "./device_packet_desc_info.vue?vue&type=style&index=0&id=3ff2583b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2583b",
  null
  
)

export default component.exports